module.exports = "/deep/ .container article ul li:before {\n  content: \"\";\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/manage-applications/allocate-applications/allocate-applications.component.css
// module id = ./src/app/manage-applications/allocate-applications/allocate-applications.component.css
// module chunks = main